module.exports = __webpack_public_path__ + "media/src/website/images/locations/germering/01-c2d2365b65d5356e14ec3717c4dc3733.jpg";